import React from 'react';
import trim from 'lodash/trim';

const nl2br = (str = '', breakSpace = 1, removeBlankLine = true) => {
  if (typeof str !== 'string') return str;

  const breakElement = Array(breakSpace).fill(null).map((_, index) => (
    <React.Fragment key={index}>
      <br />
    </React.Fragment>
  ));

  const splittedString = removeBlankLine ? str.split('\n').filter((e) => trim(e).length > 0) : str.split('\n');

  return splittedString.map((line, index, array) => (
    <React.Fragment key={index}>
      {line}
      {index < (array.length - 1) && breakElement}
    </React.Fragment>
  ));

};

// Replace all new line characters with <br /> tag but return as string instead of ReactNode
export const replaceNl2br = (str = '', breakSpace = 1, removeBlankLine = true) => {
  if (typeof str !== 'string') return str;

  return str.replace(/\n/g, Array(breakSpace).fill(null).map(() => '<br />').join(''));
}

export default nl2br;
